export default __webpack_public_path__ + "static/media/ISpic.315709ed.png";